


























import { Vue, Component, Prop, PropSync } from "vue-property-decorator";
import { FileList as IFileList } from "@/api/models/file-list";
import { FileItem as IFileItem } from "@/api/models/file-item";
import { Folder as IFolder } from "@/api/models/folder";
import { Directory as IDirectory } from "@/api/models/directory";
import { Company as ICompany } from "@/api/models/company";
import FileManagerTableItemFolder from "@/components/files/FileManagerTableItemFolder.vue";
import FileManagerTableItemFile from "@/components/files/FileManagerTableItemFile.vue";
import DeleteMaterialModal from "@/components/form/DeleteMaterialModal.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CFileManager from "@/components/fileManager/CFileManager.vue";

@Component({
  components: {
    CFileManager,
    CustomButton,
    FileManagerTableItemFile,
    FileManagerTableItemFolder,
    DeleteMaterialModal
  }
})
export default class FileManager extends Vue {
  @Prop({ default: true }) showUserFiles?: boolean;
  @Prop({ default: true }) showCompanyFiles?: boolean;
  @Prop({ default: false }) showOnlyImages?: boolean;
  @Prop({ default: true }) showNotImage?: boolean;
  @Prop({ default: true }) isChooseSingleFile?: boolean;
  @Prop() companyInfo?: ICompany;
  @Prop({ default: false }) popup!: boolean;
  @PropSync("popupIsOpen") popupOpen!: boolean;
  @Prop({ default: true }) isShowCopyAndViewIcon?: boolean;
  @Prop() defaultDisk!: string;
  files!: IFileList;
  selectedFileType!: string;
  selectedFileToUpload: Array<File> = [];
  selectedFileInTable!: IFileItem;
  selectedFileInTableId!: string | undefined;
  selectedCompany!: string;
  selectedFolder: string = "/";
  directory!: IDirectory;
  folderWay: Array<IFolder> = [];
  disableLoad: boolean = false;

  data() {
    return {
      selectedFileInTable: {},
      newFolderName: undefined,
      selectedFileInTableId: undefined,
      directory: undefined,
      files: undefined,
      selectedFileType: "userFiles",
      selectedCompany: undefined
    };
  }

  get pixelRatio() {
    return window.devicePixelRatio;
  }

  get screenWidth() {
    return this.$store.getters.SCREEN_WIDTH;
  }

  selectFile(file: IFileItem) {
    this.selectedFileInTable = file;
    this.selectedFileInTableId = file.id;
    this.$emit("sendFile", file);
    this.popupOpen = false;
    this.selectedFileInTable = {} as IFileItem;
    this.selectedFileInTableId = undefined;
  }

  sendFile(file: any) {
    this.popupOpen = false;
    this.$emit("sendFile", file);
  }
}
